var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.topContributors.length && _vm.topProjects.length
    ? _c("div", { staticClass: "top-contributors-container" }, [
        _c("div", { staticClass: "title-container" }, [
          _c("div", { staticClass: "title-wrapper" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("homePage.topContributors")))
                ]),
                _c("Information", [
                  _c("div", { staticClass: "hint-read-more" }, [
                    _c("p", { staticClass: "margin-bottom" }, [
                      _vm._v(_vm._s(_vm.$t("homePage.topContributorsHint")))
                    ]),
                    _c(
                      "a",
                      {
                        attrs: { href: "#", id: "readMore" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openFaq.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("homePage.readMore")))]
                    )
                  ])
                ])
              ],
              1
            ),
            _c("div", { staticClass: "sub-title" }, [
              _vm._v(_vm._s(_vm.$t("homePage.meetMostEngaged")))
            ])
          ])
        ]),
        _c("div", { staticClass: "projects-and-contributors-container" }, [
          _c(
            "div",
            { ref: "scrollContainer", staticClass: "contributors-container" },
            [
              _vm._l(_vm.topContributors, function(contributor, index) {
                return _c(
                  "div",
                  {
                    staticClass: "contributor",
                    class: _vm.selectedContributor === index ? "selected" : "",
                    on: {
                      click: function($event) {
                        _vm.selectedContributor = index
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "number" }, [
                      _vm._v(_vm._s(index + 1))
                    ]),
                    _c("div", { staticClass: "names" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(contributor.fullName))
                      ]),
                      _c("div", { staticClass: "email" }, [
                        _vm._v(_vm._s(contributor.email))
                      ])
                    ])
                  ]
                )
              }),
              _c(
                "div",
                {
                  staticClass: "explore-all-projects",
                  on: { click: _vm.goToProjects }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("homePage.exploreAllProjects")) + " "
                  ),
                  _c("img", {
                    staticClass: "arrow",
                    attrs: {
                      src: require("@/drc/assets/images/round-arrow-right.svg"),
                      alt: "arrow-right"
                    }
                  }),
                  _c("img", {
                    staticClass: "arrow-hover",
                    attrs: {
                      src: require("@/drc/assets/images/round-arrow-right-hover.svg"),
                      alt: "arrow-right"
                    }
                  })
                ]
              )
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "projects-container" },
            _vm._l(_vm.topProjects[_vm.selectedContributor], function(
              project,
              index
            ) {
              return _c(
                "div",
                { key: index, staticClass: "single-project-container" },
                [
                  _c("ProjectCard", {
                    attrs: { project: project, forceList: !_vm.isMobileDevice }
                  })
                ],
                1
              )
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }